import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

type YearContextType = {
  selectedYear: string | undefined;
  setSelectedYear: Dispatch<SetStateAction<string | undefined>>;
};

const YearContext = createContext<YearContextType | undefined>(undefined);

export function YearProvider({ children }: { children: React.ReactNode }) {
  const [selectedYear, setSelectedYear] = useState<string | undefined>(undefined);

  const contextValue = useMemo(() => ({ selectedYear, setSelectedYear }), [selectedYear]);

  return <YearContext.Provider value={contextValue}>{children}</YearContext.Provider>;
}

export const useYear = () => {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
};
